import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformanceCustomFieldRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-custom-field',
	path: '/jira/settings/system/performance/metrics/customfield',
};
